import { useQuery } from "react-query";
import authAPI from "../authAPI";

export const useGroupTree = (groupId, includeHidden = false, options = {}) => {
  return useQuery(
    ["group", "tree", groupId, includeHidden],
    () => authAPI.getGroupTree(groupId, includeHidden),
    {
      enabled: !!groupId,
      ...options,
    }
  );
};
